export default __webpack_public_path__ + "static/Willie.Jin.Resume.April.2021-e08e4fda9b30a5d7d1eaf0b249f09858.pdf";